const DEFAULT_CONFIG = {
  api_base_url: "http://localhost:5004"
};

let appConfig = { ...DEFAULT_CONFIG };

function normalizeBaseUrl(value) {
  return String(value || "").trim().replace(/\/+$/, "");
}

export async function loadAppConfig() {
  try {
    const response = await fetch("/app-config.json", { cache: "no-store" });
    if (!response.ok) {
      appConfig = { ...DEFAULT_CONFIG };
      return appConfig;
    }

    const config = await response.json();
    appConfig = {
      ...DEFAULT_CONFIG,
      ...config,
      api_base_url: normalizeBaseUrl(config.api_base_url)
    };
  } catch {
    appConfig = { ...DEFAULT_CONFIG };
  }

  return appConfig;
}

export function getAppConfig() {
  return appConfig;
}

export function getApiBaseUrl() {
  return normalizeBaseUrl(appConfig.api_base_url);
}

export function apiUrl(path) {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  const baseUrl = getApiBaseUrl();
  if (!baseUrl) {
    return path;
  }

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${baseUrl}${normalizedPath}`;
}

export function hubUrl(path) {
  return apiUrl(path);
}
